module.exports = __webpack_public_path__ + "383e962afe0b28a9f7ea79b79616f048.MP3";